import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function ErrorPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const error = params.get('error') || 'Произошла непредвиденная ошибка';
  const backUrl = params.get('back') || '/';

  return (
    <main className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-10">
      <div className="max-w-md w-full bg-white rounded-2xl shadow p-6 text-center">
        <div className="text-red-600 mb-4">
          <svg className="mx-auto w-16 h-16" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 
              10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
        </div>
        <p className="text-gray-800 text-sm mb-6">{error}</p>
        <button
          onClick={() => navigate(backUrl)}
          className="px-5 py-2 bg-primary text-white rounded-md font-medium text-sm hover:bg-primary/90"
        >
          Вернуться назад
        </button>
        <button 
          onClick={() => navigate('/')}
          className="mt-6 px-4 py-2 bg-secondary text-white rounded-md hover:bg-secondary/90 transition"
        >
          Вернуться на главную
        </button>
      </div>
    </main>
  );
}
